export enum enumDLISubProducts {
  'Classic Low' = 1,
  'Classic Medium',
  'Classic High',
  'Wizzit',
  'Medibucks',
  'GAP',
  'Test',
  'Intecon',
  'Classic Foreigner',
  'Lite Low',
  'Classic Lite FICA Lite',
  'Classic FICA Lite',
  'Classic Full FICA',
  'Classic Non F2F',
  'Classic FF High',
  'Wizzit FF',
  'Wizzit FICA lite',
  'MicroLender',
  'Business Group',
  'Business Platinum',
  'Business Silver',
  'Concession',
  'Concession Max',
  'Concession Volume',
  'Microlender',
  'Microlender Max',
  'ComMB',
  'Testwb',
  'AFT Personeel',
  'Allocated Merchant',
  'Cash Access',
  'Classic Lite Full FICA',
  'Client NF2F',
  'Client FICA Lite',
  'Client Full FICA',
  'EPA Group',
  'Flexifusion',
  'Intecon Merchant',
  'mB EWallet',
  'mB Executive FICA Lite',
  'mB Full Spectrum Merchant',
  'mB Insurance',
  'mB OMHP Merchant',
  'mB Wallet Merchant',
  'Office Account',
  'PayM8t Staff',
  'SS SASSA',
  'Universal Business',
  'Wealth and Rewards',
  'Wizzit Business',
  'oldClosed',
  'Classic X FICA Lite',
  'Classic X Full FICA',
  'Classic Plus FICA Lite',
  'Classic Plus Full FICA',
  'Medibucks FICA Lite',
  'Medibucks Non F2F',
  'Amber Personnel FICA Lite',
  'Amber Personnel Full FICA',
  'Classic Lite NF2F',
  'B010000',
  'B07000',
  'B05000',
  'B04000',
  'B03000',
  'B02000',
  'B01500',
  'B01000',
  'B00750',
  'B00500',
  'B00250',
  'B00200',
  'B00150',
  'B00100',
  'mB Executive FF',
  'I080',
  'I040',
  'I025',
  'FICA Lite 25',
  'FICA Lite 40',
  'Full FICA 80',
  'Full FICA 200',
  'Full FICA 500',
  'Full FICA 1000',
  'Full FICA 9999',
  'FICA NF2F',
  'Full FICA 350'
}

export namespace enumDLISubProducts {
  export function values() {
    return Object.keys(enumDLISubProducts).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
